import { getUserName } from 'Global/Helpers/userHelpers'
import { hasPermission } from 'Components/Permissions/utils'

export const isRequestCreator = (request, user) => {
  if (request) {
    if (request.createdBy) {
      return request.createdBy.id === user.id
    }
  }

  return false
}

export const buildRequestButton = (request, user, userPermissions) => {
  if (request) {
    if (isRequestCreator(request, user)) {
      return 'Remove Request'
    } else if (hasPermission('rug.action.deleteRequestDesignerPicture', userPermissions)) {
      return `Remove Request by ${getUserName(request.createdBy)}`
    } else {
      return `Requested by ${getUserName(request.createdBy)}`
    }
  }

  return 'Request Designer Picture'
}

export const buildRequestPopup = (request, user, userPermissions) => {
  if (request) {
    if (isRequestCreator(request, user)) {
      return 'Remove Designer Picture Request'
    } else if (hasPermission('rug.action.deleteRequestDesignerPicture', userPermissions)) {
      return `Remove Designer Picture Request (by ${getUserName(request.createdBy)})`
    } else {
      return `Designer Picture Requested by ${getUserName(request.createdBy)}`
    }
  }

  return 'Request Designer Picture'
}

export const buildIsMasterpieceText = isMasterpiece => (isMasterpiece ? 'Unmark as Masterpiece' : 'Mark as Masterpiece')

export const buildMFDText = markedForDesigners => (markedForDesigners ? 'Unmark for Designers' : 'Mark for Designers')
